import { render, staticRenderFns } from "./LayIntarTranslate.vue?vue&type=template&id=1132a923&scoped=true&"
import script from "./LayIntarTranslate.vue?vue&type=script&lang=js&"
export * from "./LayIntarTranslate.vue?vue&type=script&lang=js&"
import style0 from "./LayIntarTranslate.vue?vue&type=style&index=0&id=1132a923&lang=less&scoped=true&"
import style1 from "./LayIntarTranslate.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1132a923",
  null
  
)

export default component.exports